export const CHANNEL_BLOCK_REASON = Object.freeze({
    NO_CONVERSATION: 'no_conversation',
    NO_SENDER: 'no_sender',
    CHANNEL_INACTIVE: 'channel_inactive',
    SESSION_EXPIRED: 'session_expired',
    UNSUPPORTED_CHANNEL: 'unsupported_channel',
} as const);

export const SESSION_WINDOW = Object.freeze({
    OPEN: 'open',
    EXPIRED: 'expired',
    UNKNOWN: 'unknown',
} as const);

export const WHATSAPP_SESSION_WINDOW_HOURS = 24;

/** Provider name used by the `channels` conversation mode for Meta (WSP). */
export const META_CHANNEL_PROVIDER = 'meta';
